import React, { SVGProps } from 'react';
import { Colors } from '../../../styles/colors.ts';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Advarsel: React.FC<SvgProps> = ({
	pathFill = Colors.information.secondaryError,
	...props
}) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g clipPath='url(#clip0_268_1843)'>
				<path
					d='M8.97538 2.25088C8.67526 2.25088 8.38921 2.36811 8.17819 2.57913L2.57913 8.17819C2.36811 8.38921 2.25088 8.67526 2.25088 8.97538V15.0246C2.25088 15.3247 2.36811 15.6108 2.57913 15.8218L0.989449 17.4115C0.356389 16.7784 0 15.9203 0 15.0246V8.97538C0 8.07972 0.356389 7.22157 0.989449 6.58851L6.58851 0.989449C7.22157 0.356389 8.07972 0 8.97538 0H15.0246C15.9203 0 16.7784 0.356389 17.4115 0.989449L23.0105 6.58851C23.6436 7.22157 24 8.07972 24 8.97538V15.0246C24 15.9203 23.6436 16.7784 23.0105 17.4115L17.4115 23.0105C16.7784 23.6436 15.9203 24 15.0246 24H8.97538C8.07972 24 7.22157 23.6436 6.58851 23.0105L0.989449 17.4115L2.57913 15.8218L8.17819 21.4209C8.38921 21.6319 8.67526 21.7491 8.97538 21.7491H15.0246C15.3247 21.7491 15.6108 21.6319 15.8218 21.4209L21.4209 15.8218C21.6319 15.6108 21.7491 15.3247 21.7491 15.0246V8.97538C21.7491 8.67526 21.6319 8.38921 21.4209 8.17819L15.8218 2.57913C15.6108 2.36811 15.3247 2.25088 15.0246 2.25088H8.97538ZM12 5.99766C12.6237 5.99766 13.1254 6.49941 13.1254 7.12309V12.3751C13.1254 12.9988 12.6237 13.5006 12 13.5006C11.3763 13.5006 10.8746 12.9988 10.8746 12.3751V7.12309C10.8746 6.49941 11.3763 5.99766 12 5.99766ZM10.4994 16.5018C10.4994 16.1038 10.6575 15.7221 10.9389 15.4407C11.2203 15.1593 11.602 15.0012 12 15.0012C12.398 15.0012 12.7797 15.1593 13.0611 15.4407C13.3425 15.7221 13.5006 16.1038 13.5006 16.5018C13.5006 16.8997 13.3425 17.2814 13.0611 17.5628C12.7797 17.8442 12.398 18.0023 12 18.0023C11.602 18.0023 11.2203 17.8442 10.9389 17.5628C10.6575 17.2814 10.4994 16.8997 10.4994 16.5018Z'
					fill={pathFill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_268_1843'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
